/**
 * @generated SignedSource<<29553362f1cef877309db445c48df90d>>
 * @relayHash 53eb9fa8cec0a522c06e9697c10f440b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 0e7f7022453c20fb771fa2185effa02f458d286aad7e6ce54aeb8f5bfb846a33

import type { ConcreteRequest } from 'relay-runtime';
export type CommentsType = "FOOTER" | "INLINE" | "%future added value";
export type SummaryType = "BLOGPOST" | "PAGE" | "%future added value";
export type useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery$variables = {
  commentsType: CommentsType;
  contentId: string;
  contentType: SummaryType;
};
export type useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery$data = {
  readonly getCommentsSummary: {
    readonly contentId: string;
    readonly language: string;
    readonly summary: string;
    readonly summaryId: string;
  } | null;
};
export type useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery = {
  response: useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery$data;
  variables: useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "commentsType"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentType"
},
v3 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "commentsType",
        "variableName": "commentsType"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "contentType",
        "variableName": "contentType"
      }
    ],
    "concreteType": "SmartFeaturesCommentsSummary",
    "kind": "LinkedField",
    "name": "getCommentsSummary",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentId"
      },
      {
        "kind": "ScalarField",
        "name": "summary"
      },
      {
        "kind": "ScalarField",
        "name": "summaryId"
      },
      {
        "kind": "ScalarField",
        "name": "language"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery",
    "selections": (v3/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery",
    "selections": (v3/*: any*/)
  },
  "params": {
    "cacheID": "53eb9fa8cec0a522c06e9697c10f440b",
    "id": "0e7f7022453c20fb771fa2185effa02f458d286aad7e6ce54aeb8f5bfb846a33",
    "metadata": {},
    "name": "useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery",
    "operationKind": "query",
    "text": "query useCombinedCommentsSummariesQueriesInlineCommentsSummaryQuery($contentId:ID!,$contentType:SummaryType!,$commentsType:CommentsType!){getCommentsSummary(contentId:$contentId,contentType:$contentType,commentsType:$commentsType){contentId,summary,summaryId,language}}"
  }
};
})();

(node as any).hash = "6db2d91039b90f64f08e4e052c0a32d7";

export default node;
